import React, { useMemo } from "react";
import GymnasiumStage from "../stages/GymnasiumStage";
import useResponsiveStageAsset from "../../../hooks/useResponsiveStageAsset";
import StagePageLayout from "./StagePageLayout";

export default function GymnasiumStagePage({ stage, onDone, onSessionPointsChange }) {
  const svgAsset = useResponsiveStageAsset(stage.assets);
  const data = useMemo(() => ({ ...stage.data, svgAsset: svgAsset || stage.data.svgAsset }), [stage, svgAsset]);
  return (
    <StagePageLayout stageId={stage.id} theme={stage.theme}>
      <GymnasiumStage data={data} onDone={onDone} onSessionPointsChange={onSessionPointsChange} />
    </StagePageLayout>
  );
}
